(() => {
  const initializeMegaMenus = (scope = document) => {
    const desktopQuery = window.matchMedia('(min-width: 821px)');

    scope.querySelectorAll('[data-lb-mega-header]').forEach((header) => {
      if (header.dataset.lbMegaReady === 'true') return;
      header.dataset.lbMegaReady = 'true';
    const triggers = Array.from(header.querySelectorAll('[data-lb-mega-trigger]'));
    const panels = Array.from(header.querySelectorAll('[data-lb-mega-panel]'));
    const accountMenu = header.querySelector('.lb-v1-account-menu');
    let closeTimer;

    const closeMenus = () => {
      window.clearTimeout(closeTimer);
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      panels.forEach((panel) => { panel.hidden = true; });
      header.classList.remove('is-mega-open');
    };

    const openMenu = (menuName) => {
      window.clearTimeout(closeTimer);
      if (accountMenu) accountMenu.open = false;
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(trigger.dataset.lbMegaTrigger === menuName));
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.lbMegaPanel !== menuName;
      });
      header.classList.add('is-mega-open');
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (trigger.getAttribute('aria-expanded') === 'true' && event.detail === 0) {
          closeMenus();
        } else {
          openMenu(trigger.dataset.lbMegaTrigger);
        }
      });

      trigger.addEventListener('mouseenter', () => {
        if (desktopQuery.matches) openMenu(trigger.dataset.lbMegaTrigger);
      });
    });

    panels.forEach((panel) => {
      panel.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
    });

    if (accountMenu) {
      accountMenu.addEventListener('toggle', () => {
        if (accountMenu.open) closeMenus();
      });
    }

    header.addEventListener('mouseleave', () => {
      if (desktopQuery.matches) closeTimer = window.setTimeout(closeMenus, 180);
    });

    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenus();
        triggers.find((trigger) => trigger.getAttribute('aria-expanded') === 'true')?.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        closeMenus();
        if (accountMenu) accountMenu.open = false;
      }
    });

    const stateTabs = Array.from(header.querySelectorAll('[data-lb-state-tab]'));
    const statePanels = Array.from(header.querySelectorAll('[data-lb-state-panel]'));

    const selectState = (tab) => {
      const stateKey = tab.dataset.lbStateTab;
      stateTabs.forEach((candidate) => {
        const isActive = candidate === tab;
        candidate.setAttribute('aria-selected', String(isActive));
        candidate.tabIndex = isActive ? 0 : -1;
      });
      statePanels.forEach((panel) => {
        panel.hidden = panel.dataset.lbStatePanel !== stateKey;
      });
    };

    stateTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectState(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % stateTabs.length;
        if (event.key === 'ArrowUp') nextIndex = (index - 1 + stateTabs.length) % stateTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = stateTabs.length - 1;
        selectState(stateTabs[nextIndex]);
        stateTabs[nextIndex].focus();
      });
    });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMegaMenus(), { once: true });
  } else {
    initializeMegaMenus();
  }

  document.addEventListener('shopify:section:load', (event) => initializeMegaMenus(event.target));
})();
